import { I01EVACONSSYSTECS_State } from '@batical/types/src'

const I01EVACONSSYSTECS: I01EVACONSSYSTECS_State = {
  bati_version: 2,
  deleted: 0,
  name: '',
  saveDate: 0,
  in_typeLogement: '0',
  in_typeCalcul: 0,
  in_t1_Ddo: 0.0,
  in_t1_ba: 0.0,
  in_t2_do: 0.0,
  in_t2_ba: 0.0,
  in_t3_ev_lav_ba: 0.0,
  in_t3_ba_do: 0.0,
  in_t4_ba: 0.0,
  in_t4_ba_do: 0.0,
  in_t56_ba: 0.0,
  in_t56_ba_do: 0.0,
  in_T56_2ba: 0.0,
  res_totalLogementStandard: 0.0,
  res_consJour: 0.0,
  res_maxVolStackagECS: 0.0,
  res_consoHPointe: 0.0,
  res_conso10mn: 0.0,
  in_tempFroid: 11.0,
  in_tempChaude: 55.0,
  res_puissanceThermique: 0.0,
  res_debit_dtu: 0.0,
  in_VolStockageECS: 0.0,
  res_puissanceSemiECS: 0.0,
  in_tempRetourEchangeur: 10.0,
  in_tempStockagePrimaire: 60.0,
  in_volumStockageAppoint: 0.0,
  res_puissanceAppoint: 0.0,
  res_maxPuissanceAppoint: 0.0,
  mode: 'none',
  calcul_code: 'I01EVACONSSYSTECS'
}

export default I01EVACONSSYSTECS
